import { kebabCase } from 'es-toolkit';
import React, { Component, ComponentType, createElement, MouseEvent } from 'react';
import { Button, IconButton, SxProps, Theme, Tooltip } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon';

interface Props {
  id?: string;
  name: string;
  sx?: SxProps<Theme>;
  icon: ComponentType<SvgIconProps>;
  title: string;

  /** defaults to `title` */
  tooltip?: string;

  /** defaults to false */
  showTitleInButton?: boolean;

  disableTooltip?: boolean;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
}

export class RowActionButton extends Component<Props> {
  onClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    if (this.props.onClick) {
      this.props.onClick(event);
    }
  };

  render() {
    const buttonProps = {
      id: this.props.id,
      sx: [...(Array.isArray(this.props.sx) ? this.props.sx : [this.props.sx])],
      onClick: this.onClick,
      className: `grid-item-button-${kebabCase(this.props.name)}`,
      disabled: this.props.disabled,
    };

    return (
      <Tooltip
        disableInteractive
        title={this.props.tooltip ?? this.props.title}
        disableFocusListener
        disableHoverListener={this.props.disableTooltip ? true : undefined}
      >
        <span>
          {this.props.showTitleInButton ? (
            <Button
              key={this.props.name}
              {...buttonProps}
              variant="text"
              color="inherit"
              startIcon={createElement(this.props.icon)}
            >
              {this.props.title}
            </Button>
          ) : (
            <IconButton key={this.props.name} {...buttonProps} size="small">
              {createElement(this.props.icon)}
            </IconButton>
          )}
        </span>
      </Tooltip>
    );
  }
}
